/**
 * @file hooks/biz/list/toolbar 按钮区和筛选区
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import {useCallback} from 'react';

import {ListOptions} from './interface';

const useToolbar = (
    options: ListOptions,
    selectedRowKeys: any[],
    checkedAll: boolean,
    loading: boolean,
    handleAction: (config: any, payload: any) => void,
    handleFilter: (filterData: any) => void,
    handleFilterDataChange: (itemChanged: any) => void,
    customFunctions: any
) => {
    const {
        bulkPosition,
        bulkConfig,
        filterConfig,
        bulkComp,
        filterComp,
        filterProps: customFilterProps,
        tableConfig
    } = options;

    const {columns} = tableConfig;

    const handleFilterItemChange = useCallback((itemChanged: any) => {
        // 业务端自定义handleFilterItemChange
        customFunctions.handleFilterItemChange && customFunctions.handleFilterItemChange(itemChanged);
    }, [customFunctions]);

    const handleFilterChange = useCallback((itemChanged: any) => {
        // zhangzhe 2019-11-20 同步给main.ts中的filterData
        handleFilterDataChange(itemChanged);
    }, [handleFilterDataChange]);

    // toolbar区域
    const withToolbar = bulkConfig || bulkComp || filterConfig || filterComp;
    // filter位置
    const filterPosition = filterConfig && filterConfig.position;
    // bulk组件属性
    const bulkProps = {
        selectedRowKeys,
        checkedAll,
        loading,
        bulkComp,
        bulkConfig,
        onHandleAction: handleAction
    };
    // filter组件属性
    const filterProps = {
        loading,
        filterComp,
        filterProps: customFilterProps,
        filterConfig,
        columns,
        onHandleFilter: handleFilter, // 发起查询
        onItemChange: handleFilterItemChange, // 筛选的某项修改处理
        onFilterDataChange: handleFilterChange
    };
    return {
        toolbarProps: {
            bulkPosition,
            withToolbar,
            filterPosition,
            bulkProps,
            filterProps
        }
    };
};

export default useToolbar;
